import PropTypes from "prop-types";
import React from "react";
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { REQUIRED_MESSAGE } from "../constants/formConstants";
import { stringOrNumberPropType } from "../util/propTypeHelper";
import TooltipIcon from "./TooltipIcon";

export default function InputRadioGroup({
  title,
  name,
  defaultValue,
  options,
  register,
  buttonDirection,
}) {
  return (
    <FormControl
      data-testid="inputRadioGroup"
      sx={{
        flexDirection: "column",
        flexWrap: "wrap",
      }}
    >
      <FormLabel>{title}</FormLabel>
      <RadioGroup
        sx={{
          marginRight: "10px",
          flexDirection: buttonDirection,
        }}
        defaultValue={defaultValue}
      >
        {options.map(({ disabled, label, value, tooltipText }) => (
          <React.Fragment key={value}>
            <FormControlLabel
              value={value}
              control={<Radio disabled={disabled} required />}
              label={label}
              {...register(name, {
                required: REQUIRED_MESSAGE,
              })}
              sx={{ marginRight: tooltipText ? 0 : "16px" }}
            />
            {!!tooltipText && (
              <TooltipIcon
                style={{ marginRight: "30px" }}
                title={tooltipText}
              />
            )}
          </React.Fragment>
        ))}
      </RadioGroup>
    </FormControl>
  );
}

InputRadioGroup.propTypes = {
  buttonDirection: PropTypes.oneOf(["row", "column"]),
  defaultValue: stringOrNumberPropType,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      disabled: PropTypes.bool,
      label: PropTypes.string.isRequired,
      value: stringOrNumberPropType.isRequired,
      tooltipText: PropTypes.string,
    })
  ).isRequired,
  register: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};
